<div class="credit-result-historical-contracts">
    <div class="row">
        <div class="col-12">
            @if (hasError) {
                <div class="mb-4">
                    <message-box type="warn">Unable to load historical contracts</message-box>
                </div>
            } @else {
                <div [ngClass]="{hidden: (loader.tableLoading.inProgress$ | async), 'table-section': true}">
                    <table mat-table [dataSource]="dataSource" class="width-100 mb-4">
                        @for (column of columnsToDisplay; track column) {
                            <ng-container matColumnDef="{{column}}">
                                <th mat-header-cell *matHeaderCellDef> 
                                    <div class="cell">{{getColumnTitle(column)}}</div> 
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="cell">
                                        @if (column === 'WDV' && element[column] !== null && element[column] !== undefined) {
                                            {{element[column] | looseCurrency}}
                                        } @else {
                                            {{formatValue(element[column], column)}}
                                        }
                                    </div>
                                </td>
                                <td mat-footer-cell *matFooterCellDef>
                                    <div class="cell">
                                        @if (column === 'EntityName') {
                                            <strong>Total</strong>
                                        } @else if (column === 'WDV') {
                                            <strong>{{totalWDV | looseCurrency}}</strong>
                                        }
                                    </div>
                                </td>
                            </ng-container>
                        }
                
                        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                        <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="example-element-row">
                        </tr>
                        <tr mat-footer-row *matFooterRowDef="columnsToDisplay" [hidden]="!dataSource.length"></tr>
                    </table>

                    @if (!dataSource.length && !(loader.tableLoading.inProgress$ | async)) {
                        <table>
                            <tr>
                                <td class="not-found">No historical contracts found</td>
                            </tr>
                        </table>
                    }
                </div>
            }
        </div>
    </div>
</div>

